import { ChangeEvent, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  OutlinedInput,
  Checkbox,
  ListItemText,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
} from "@mui/material";
import {
  DatePicker,
  TimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";
import EditText from "../../components/editText";
import ViewCard from "../../Modals/viewCard";

interface ExpertCard {
  id: number;
  image: string;
  category?: string;
  title: string;
  description: string;
  authorImage?: string;
  authorName?: string;
  makerImage?: string;
  makerName?: string;
  makerDesignation?: string;
  readTime: string;
  tags: string[];
  videoIcon?: boolean;
  aiPick?: boolean;
  quickListen?: boolean;
}

interface ExpertCardProps {
  expertCards: ExpertCard[];
}
const categories = [
  "Styling Tips",
  "How To Use",
  "Behind the Brand",
  "Care & Maintenance",
];

const allProducts = [
  "Red Dress",
  "Winter Jacket",
  "Leather Belt",
  "Sneakers",
  "Sunglasses",
];

const languages = ["English", "Arabic", "French", "Spanish"];

const AddBlog = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [coverImage, setCoverImage] = useState<File | null>(null);
  const [coverPreview, setCoverPreview] = useState("");
  const [category, setCategory] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [content, setContent] = useState(""); // Rich text placeholder
  const [relatedProducts, setRelatedProducts] = useState<string[]>([]);
  const [status, setStatus] = useState("draft");
  const [scheduleDate, setScheduleDate] = useState<any>(null);
  const [scheduleTime, setScheduleTime] = useState<any>(null);
  const [tags, setTags] = useState("");
  const [seoTitle, setSeoTitle] = useState("");
  const [seoDesc, setSeoDesc] = useState("");
  const [language, setLanguage] = useState("English");

  const handleImageUpload = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setCoverImage(file);
      setCoverPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = () => {
    const payload = {
      title,
      coverImage,
      category,
      excerpt,
      content,
      relatedProducts,
      status,
      scheduleDate,
      scheduleTime,
      tags,
      seoTitle,
      seoDesc,
      language,
    };
  };
  const [legal3, setLegal3] = useState<string>("");
  const existingTitles = [
    "How to Set Up Your Store",
    "Managing Your Products",
    "Understanding Payments",
    "Creating Promotions",
  ];
  const [quality, setQuality] = useState("");
  const [loadingAI, setLoadingAI] = useState(false);
  const [openCardModal, setOpenCardModal] = useState(false);
  const storeStoryTemplates = [
    "Born from a passion for craftsmanship, our store celebrates local artisans and the beauty of handmade traditions...",
    "Inspired by UAE heritage, our brand blends modern aesthetics with timeless cultural values...",
    "Built by creators for creators, our store is a home for unique products made with soul and purpose...",
  ];
  return (
    <>
      <div className="main_title">
        <h1>Add Journal</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>-
          <button onClick={() => navigate("/blogs")}>Manage Journals</button> -
          Add Journal
        </p>
      </div>

      <div className="cards custom_form_details">
        <div className="form">
          <div className="gap_m">
            {/* Article Title */}

            {/* Cover Image */}
            <div className="control_group w_100">
              <label>Cover Image</label>
              <label className="upload_image no_radius" htmlFor="cover-upload">
                <input
                  id="cover-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleImageUpload}
                />
                <span className="upload_image_holder">
                  <figure
                    className="add_img"
                    style={{ height: "200px", width: "200px" }}
                  >
                    <img
                      src={coverPreview || "/static/images/placeholder.png"}
                      alt="cover"
                    />
                    <span className="upload_img_icon">
                      <img src="/static/images/edit2_icon.svg" alt="icon" />
                    </span>
                  </figure>
                </span>
              </label>
              <Button
                className="btn btn_primary sm"
                style={{ marginTop: "20px", width: "200px" }}
              >
                {" "}
                AI image enhancer{" "}
              </Button>
            </div>

            {/* Category */}
            {/* Category */}
            <div className="control_group w_50">
              <label
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span>Category</span>
                <Chip
                  label="Top Performing: Styling Tips"
                  color="success"
                  size="small"
                />
              </label>

              <FormControl fullWidth>
                <Select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Category
                  </MenuItem>

                  {/* Auto-suggest based on content */}
                  {content.length > 30 && (
                    <MenuItem value="Suggested">
                      💡 Suggested: {categories[0]}
                    </MenuItem>
                  )}

                  {categories.map((cat) => (
                    <MenuItem key={cat} value={cat}>
                      {cat}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Excerpt */}
            {/* Excerpt */}
            <div className="control_group w_50 ai_rec_btn">
              <label>Short Summary / Excerpt</label>

              <TextField
                placeholder="Write a short summary"
                value={excerpt}
                onChange={(e) => setExcerpt(e.target.value)}
                fullWidth
                multiline
                rows={3}
              />
              <Button
                className="btn btn_primary sm"
                onClick={() => setExcerpt(content.slice(0, 120) + "...")}
              >
                <img src="/static/images/ai_icon.svg" alt="" /> Generate Summary
                with AI
              </Button>
            </div>

            {/* Main Content */}
            <div className="control_group w_100 ai_rec_btn">
              <label>Description(Min:50 words)</label>
              <Select
                fullWidth
                value={"default"}
                className="select_abs"
                style={{ top: "45px", right: "20px" }}
              >
                <MenuItem disabled value="default">
                  Select Template
                </MenuItem>
                {storeStoryTemplates.map((template, index) => (
                  <MenuItem value="All">{template}</MenuItem>
                ))}
              </Select>
              <div className="rich_editor_mock">
                <EditText content={legal3} setContent={setLegal3} />
              </div>
              <Button
                className="btn btn_primary sm"
                onClick={() => setExcerpt(content.slice(0, 120) + "...")}
              >
                <img src="/static/images/ai_icon.svg" alt="" /> Enhance with AI
              </Button>
            </div>
            <div className="control_group w_100 ai_rec_btn">
              <label style={{ display: "flex", gap: "10px" }}>
                <span>Article Title</span>

                {/* Title Quality Badge */}

                <Chip
                  label="Good"
                  color={
                    quality === "Strong"
                      ? "success"
                      : quality === "Good"
                      ? "warning"
                      : "error"
                  }
                  size="small"
                />
              </label>

              {/* Title Input */}
              <TextField
                placeholder="Enter article title (max 100 characters)"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                fullWidth
              />

              <Button className="btn btn_primary sm">
                <img src="/static/images/ai_icon.svg" alt="icon" />
                Enhance with AI
              </Button>
            </div>
            <div className="control_group w_100 wrap_viewDemo_steps">
              <label htmlFor="">Video / Reels</label>
              <div className="upload_box">
                <label className="upload_action">
                  <input type="file" />
                  <p>
                    <img src="/static/images/upload_icon.svg" alt="icon" />
                    <strong>Upload Video/Reel</strong>
                  </p>
                </label>
              </div>
            </div>
            {/* Related Products */}
            <div className="control_group w_100">
              <label>Related Products</label>
              <FormControl fullWidth>
                <Select
                  multiple
                  value={relatedProducts}
                  onChange={(e) =>
                    setRelatedProducts(e.target.value as string[])
                  }
                  input={<OutlinedInput />}
                  renderValue={(selected) => selected.join(", ")}
                >
                  {allProducts.map((product) => (
                    <MenuItem key={product} value={product}>
                      <Checkbox checked={relatedProducts.includes(product)} />
                      <ListItemText primary={product} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Status & Scheduling */}
            <div className="control_group w_50">
              <label>Status & Publish Settings</label>
              <RadioGroup
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <FormControlLabel
                  value="draft"
                  control={<Radio />}
                  label="Draft"
                />
                <FormControlLabel
                  value="publish"
                  control={<Radio />}
                  label="Publish Now"
                />
                <FormControlLabel
                  value="schedule"
                  control={<Radio />}
                  label="Schedule"
                />
              </RadioGroup>
            </div>

            {/* Schedule date/time only when needed */}
            {status === "schedule" && (
              <>
                <div className="control_group w_50">
                  <label>Schedule Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={scheduleDate}
                      onChange={setScheduleDate}
                    />
                  </LocalizationProvider>
                </div>

                <div className="control_group w_50">
                  <label>Schedule Time</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      value={scheduleTime}
                      onChange={setScheduleTime}
                    />
                  </LocalizationProvider>
                </div>
              </>
            )}

            {/* Tags */}
            <div className="control_group w_50">
              <label>Tags / Keywords(Max Limit: 10)</label>
              <TextField
                placeholder="Enter tags separated by commas"
                value={tags}
                onChange={(e) => setTags(e.target.value)}
                fullWidth
              />
            </div>

            {/* Reading time */}
            <div className="control_group w_50">
              <label>Reading Time (auto-calculated)</label>
              <TextField
                disabled
                placeholder="Auto (based on content length)"
              />
            </div>

            {/* SEO Title */}
            <div className="control_group w_50">
              <label>SEO Title</label>
              <TextField
                placeholder="Auto-generated or custom SEO title"
                value={seoTitle}
                onChange={(e) => setSeoTitle(e.target.value)}
                fullWidth
              />
            </div>

            {/* SEO Description */}
            <div className="control_group w_50">
              <label>SEO Description</label>
              <TextField
                placeholder="Search-friendly description for Google"
                value={seoDesc}
                onChange={(e) => setSeoDesc(e.target.value)}
                fullWidth
                multiline
                rows={3}
              />
            </div>

            {/* Language Selector */}
            <div className="control_group w_50">
              <label>Language</label>
              <FormControl fullWidth>
                <Select
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                  displayEmpty
                >
                  {languages.map((lang) => (
                    <MenuItem key={lang} value={lang}>
                      {lang}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      </div>

      <div className="form_btn" style={{ marginTop: "20px" }}>
        <Button
          className="btn btn_primary"
          onClick={() => setOpenCardModal(true)}
        >
          Save and Preview
        </Button>
      </div>

      <ViewCard
        open={openCardModal}
        onClose={() => setOpenCardModal(false)}
        setOpen={setOpenCardModal}
      />
    </>
  );
};

export default AddBlog;
